import { render, staticRenderFns } from "./accessibility-information.vue?vue&type=template&id=b30ad85e"
import script from "./accessibility-information.vue?vue&type=script&lang=js"
export * from "./accessibility-information.vue?vue&type=script&lang=js"
import style0 from "./accessibility-information.vue?vue&type=style&index=0&id=b30ad85e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports